var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`tpl-${_setup.operation?.operationData?.idgame}`,attrs:{"id":"app"}},[(_setup.operation?.operationData)?_c('router-view'):_c('div',{staticClass:"w-full h-full flex justify-center items-center"},[_vm._v(" "+_vm._s(_setup.waitForComponent)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }